import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'

i18next
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) =>
      import(
        `../../frontend/assets/locales/${language}/${namespace}.json`
      ).catch(() => {
        console.error(
          '[i18n] could not find language/namespace in frontend/assets/locales',
          { language, namespace },
        )
      }),
    ),
  )
  .init({
    returnEmptyString: false,
    fallbackLng: 'en',
    defaultNS: false,
  })

export default i18next
